import { render } from "./SearchForm.vue?vue&type=template&id=062f1658"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"

import "./SearchForm.vue?vue&type=style&index=0&id=062f1658&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wp-adeona/wp-content/themes/adeona/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/SearchForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "062f1658"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('062f1658', __exports__)) {
    api.reload('062f1658', __exports__)
  }
  
  module.hot.accept("./SearchForm.vue?vue&type=template&id=062f1658", () => {
    api.rerender('062f1658', render)
  })

}


export default __exports__